module.exports = __webpack_public_path__ + "img/image (72).01eae49d.jpg";